export const handleJsonParse = (jsonString) => {
    let result;

    try {
        result = JSON.parse(jsonString);
        return result;
    } catch (err) {
        // console.warn(err);
        // console.info(jsonString);
        result = null;
        return result;
    }
};
